angular.module('comment')
    .component('dashboardCommentItem', {
        bindings: {
            comment: '<'
        },
        template: `
            <div class="dashboard-task-container" ng-class="{'comment-system': !$ctrl.comment.createdBy}">
                <div class="info">
                    <div class="user-thumb">
                        <user-avatar user="$ctrl.comment.createdBy" size="34" font-size="16" ng-if="$ctrl.comment.createdBy"></user-avatar>
                        <span ng-if="!$ctrl.comment.createdBy" class="comment-system-badge" uib-tooltip="Komentarz dodany automatycznie przez system">SYS</span>
                    </div>
                    <div class="task-header">
                        <div class="wrap-long-line">
                            <span ng-switch="$ctrl.comment.entityName">
                                <span ng-switch-when="pl.multisoft.document.task.Task">
                                    <a href="#/task/{{$ctrl.comment.entityId}}" class="comment-message-wrapper" ng-bind-html="$ctrl.comment.text | mentionFilter"></a>
                                </span>
                                <span ng-switch-when="pl.multisoft.document.note.NoteDTO">
                                    <a href="#/note/{{$ctrl.comment.entityId}}" class="comment-message-wrapper" ng-bind-html="$ctrl.comment.text | mentionFilter"></a>
                                </span>
                                <span class="comment-message-wrapper" ng-switch-default ng-bind-html="$ctrl.comment.text | mentionFilter"></span>
                            </span>
                        </div>
                        <div class="activity-time">
                            <abbr title="{{$ctrl.comment.createdTime | date : 'medium'}}" am-time-ago="$ctrl.comment.createdTime"></abbr>
                        </div>
                    </div>
                </div>
            </div>
        `
    })
